import axios from "axios";
import { Buffer } from "buffer";
import moment from "moment";

const API_URL = process.env.REACT_APP_API_Link;
const API_ORIGIN = process.env.REACT_APP_API_ORIGIN;
const username = process.env.REACT_APP_API_USERNAME;
const password = process.env.REACT_APP_API_PASSWORD;
const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");

const headers = {
  "Content-Type": "multipart/form-data",
  Authorization: `Basic ${token}`,
  "Access-Control-Allow-Origin": API_ORIGIN,
};

const headers2 = {
  "Content-Type": "application/json",
  Authorization: `Basic ${token}`,
  "Access-Control-Allow-Origin": API_ORIGIN,
};

const loginCustomer = (values) => {
  return axios.post(
    API_URL + "customer-login",
    {
      username: values.username,
      password: values.password,
    },
    {
      headers: headers,
    },
  );
};

const profileData = (id, apiLink) => {
  return axios.get(API_URL + apiLink + id, {
    headers: headers,
  });
};

const profileUpdate = (values, id, apiLink) => {
  return axios.put(
    API_URL + apiLink + id,
    {
      email: values.email,
      username: values.name,
      currentPassword: values.passwordOld,
      newPassword: values.password,
      confirmPassword: values.passwordNew,
    },
    {
      headers: headers2,
    },
  );
};

// add customer apis call

const uploadCustomers = (formData) => {
  return axios.post(API_URL + "upload-file", formData, {
    headers: headers,
  });
};

const getCustomersDataByIdNew = (id, type) => {
  return axios.get(API_URL + "get-customer-id-new/" + id + "/" + type, {
    headers: headers,
  });
};

const updateCustomerNew = (formData, id) => {
  return axios.post(API_URL + "update-file/" + id, formData, {
    headers: headers,
  });
};

const deleteCustomersDataNew = (id, AdminId) => {
  return axios.delete(
    API_URL + "delete-file?file_ids[]=" + [Number(id)] + "&AdminId=" + AdminId,
    {
      headers: headers2,
    },
  );
};
const deleteSelectedCustomersData = (id, AdminId) => {
  const query = id.map((id) => `file_ids[]=${id}`).join("&");
  return axios.delete(
    API_URL + "delete-file?" + query + "&AdminId=" + AdminId,
    {
      headers: headers2,
    },
  );
};
const getLoginAzureLink = (loginWith = "azure", type = "admin") => {
  return axios.get(
    `${API_URL}auth/${loginWith}/${type}`,

    {
      headers: headers2,
    },
  );
};
const getAzureLoginUserInfo = (id, type) => {
  return axios.get(
    `${API_URL}verify/${type}/login/${id}`,

    {
      headers: headers2,
    },
  );
};
const getCustomersData = (id, pageNo) => {
  return axios.get(API_URL + "index", {
    params: {
      AdminId: id,
      page: pageNo,
    },

    headers: headers,
  });
};
const viewCustomerInModel = (id) => {
  return axios.get(API_URL + "show/" + id, {
    headers: headers,
  });
};
const AdminListService = {
  getLoginAzureLink,
  getAzureLoginUserInfo,
  profileData,
  profileUpdate,
  loginCustomer,
  getCustomersData,

  uploadCustomers,
  updateCustomerNew,
  viewCustomerInModel,
  getCustomersDataByIdNew,

  deleteCustomersDataNew,
  deleteSelectedCustomersData,
};

export default AdminListService;
